"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _presence.default;
  }
});
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _has2 = _interopRequireDefault(require("lodash/has"));
require("@webex/internal-plugin-device");
var _webexCore = require("@webex/webex-core");
var _presence = _interopRequireDefault(require("./presence"));
var _config = _interopRequireDefault(require("./config"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerInternalPlugin)('presence', _presence.default, {
  payloadTransformer: {
    predicates: [{
      name: 'normalizeSingleStatusResponse',
      direction: 'inbound',
      test: function test(ctx, response) {
        // POST to /apheleia/api/v1/events
        return _promise.default.resolve((0, _has2.default)(response, 'body.eventType') && (0, _has2.default)(response, 'body.subject'));
      },
      extract: function extract(response) {
        return _promise.default.resolve(response);
      }
    }],
    transforms: [{
      name: 'normalizeSingleStatusResponse',
      direction: 'inbound',
      fn: function fn(ctx, response) {
        response.body.status = response.body.eventType;
      }
    }]
  },
  config: _config.default
});
//# sourceMappingURL=index.js.map
